import { render, staticRenderFns } from "./FAQPage.vue?vue&type=template&id=b2c9eeb8&scoped=true&"
import script from "./FAQPage.vue?vue&type=script&lang=ts&"
export * from "./FAQPage.vue?vue&type=script&lang=ts&"
import style0 from "./FAQPage.vue?vue&type=style&index=0&id=b2c9eeb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c9eeb8",
  null
  
)

export default component.exports